// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";
import useWindowSize from "../../helpers/useWindowSize";
import {
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
} from "@fluentui/react-components";
import { IStuelipos } from "../../Models/IStuelipos";
import { BOMColumns } from "./BOMColumns";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";
import AddToBedarfDialog from "../Account/Bedarfe/AddToBedarfDialog";
import { IDokument } from "../../Models/IDokument";
import DocumentViewer from "../../Controls/DocumentViewer";
import { baseUrl } from "../../helpers/constants";

// Props
interface IBOMListProps {
  bom: IStuelipos[];
  expandBom(bomItem: IStuelipos): void;
}

// Function
function BOMList(props: IBOMListProps) {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 800;
  const [addToBedarf, setAddToBedarf] = useState<
    IAddUserBedarfPosition | undefined
  >(undefined);
  const showPdfViewer = (item: IDokument) => {
    if (
      item.docFileExtension.toLowerCase().includes("pdf") ||
      item.docFileExtension.toLowerCase().includes("stl")
    ) {
      setDocumentProps({
        path:
          baseUrl + "/api/documents/GetDocumentFromPath?path=" + item.docPath,
        title: item.docFileName
          ? item.docFileName
          : item.artikelId != ""
          ? item.artikelId
          : "Dokument",
        stueliId:
          item.docFileExtension?.toLowerCase().includes("pdf") &&
          item.docPath?.includes("DOC_ETZ")
            ? item.artikelId
            : "",
      });
    }
  };
  const [documentProps, setDocumentProps] = useState<{
    path: string;
    title: string;
    stueliId: string;
  }>();
  const columns = BOMColumns({
    expandBom: (bomItem: IStuelipos) => {
      props.expandBom(bomItem);
    },
    onAddBedarf: (item: IAddUserBedarfPosition) => {
      setAddToBedarf(item);
    },
    showPdfViewer: (data: IDokument) => {
      showPdfViewer(data);
    },
    showExpandButton: true,
    showPdfViewerButton: true,
  });

  const getRowColor = (ebene: number | undefined | null) => {
    if (ebene == 1) {
      return "#faf9f8";
    } else if (ebene == 2) {
      return "#ebe8e6";
    } else if (ebene == 3) {
      return "#e3e0de";
    } else if (ebene == 4) {
      return "#d4d1cf";
    }
  };

  return (
    <>
      {documentProps && (
        <DocumentViewer
          addToBedarf={[
            (addToBedarf: any) => {
              //setAddToBedarf(addToBedarf);
            },
          ]}
          title={documentProps.title}
          path={documentProps.path}
          productId={undefined}
          stueliId={documentProps.stueliId}
          onDismiss={() => {
            setDocumentProps({ title: "", path: "", stueliId: "" });
          }}
          canDownload={true}
        />
      )}
      <AddToBedarfDialog
        onDismiss={() => {
          setAddToBedarf(undefined);
        }}
        addUserBedarfPosition={addToBedarf}
      />
      <div className="lueb-InnerContentBlockPadding2px">
        <div style={{ padding: 5, overflow: "auto" }}>
          <DataGrid
            items={props.bom}
            columns={columns}
            resizableColumns={true}
            columnSizingOptions={{
              expand: {
                minWidth: 80,
                defaultWidth: 80,
              },
              position: {
                minWidth: 60,
                defaultWidth: 60,
              },
              artikelId: {
                minWidth: 100,
                defaultWidth: 100,
              },
              isVerschleissteil: {
                minWidth: 60,
                defaultWidth: 60,
              },
              menge: {
                minWidth: 60,
                defaultWidth: 60,
              },
              benennung: {
                minWidth: 190,
                defaultWidth: 500,
              },
              actions: {
                minWidth: 90,
                defaultWidth: 90,
              },
            }}
          >
            <DataGridHeader>
              <DataGridRow>
                {({ renderHeaderCell }) => (
                  <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                )}
              </DataGridRow>
            </DataGridHeader>
            <DataGridBody<IStuelipos>>
              {({ item, rowId }) => (
                <DataGridRow<any>
                  key={rowId}
                  style={{ backgroundColor: getRowColor(item.ebene) }}
                >
                  {({ renderCell }) => (
                    <DataGridCell>{renderCell(item)}</DataGridCell>
                  )}
                </DataGridRow>
              )}
            </DataGridBody>
          </DataGrid>
        </div>
      </div>
    </>
  );
}

// Export Function
export default BOMList;
